import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

/**
 * Top-level page header bar. A flex row container.
 * Place Breadcrumb, HeaderTitle, and optionally HeaderEnd as children.
 *
 * @param {React.ReactNode} props.children
 * @param {string}          [props.className]
 */
const HeaderBar = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>{children}</div>
  );
};

export default HeaderBar;

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "40px",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    marginBottom: "16px",
  },
}));
